import React, { useState } from 'react';
import { useInView } from 'react-intersection-observer';

const lembagaData = [
  {
    id: 'masjid', tab: '🕌 Masjid',
    icon: '🕌', title: 'Program Pemberdayaan untuk Masjid',
    desc: 'Masjid bukan sekadar tempat ibadah — ia adalah pusat peradaban. MASQUDE membantu masjid menjadi institusi yang aktif, transparan, dan berdaya secara ekonomi dan sosial.',
    items: [
      { ico: '📱', title: 'MASQUDE Digital', desc: 'Pemberdayaan digital keuangan, data jamaah, ZISWAF, dan tabungan qurban via Maslam' },
      { ico: '📖', title: "MASQUDE Qur'an", desc: "Distribusi Al-Qur'an berkualitas dan program edukasi HikmahQu untuk jamaah" },
      { ico: '🌿', title: 'MASQUDE Green', desc: 'Program penghijauan, ketahanan pangan, dan distribusi pupuk organik area masjid' },
      { ico: '💼', title: 'MASQUDE Preneur', desc: 'Jadikan masjid pusat ekonomi jamaah melalui jaringan reseller qurban NusaQu' },
    ],
  },
  {
    id: 'yayasan', tab: '🏢 Yayasan',
    icon: '🏢', title: 'Program Pemberdayaan untuk Yayasan',
    desc: 'Yayasan membutuhkan program yang terstruktur, transparan, dan berdampak. MASQUDE menyediakan ekosistem lengkap untuk penguatan kapasitas dan kemandirian yayasan keislaman.',
    items: [
      { ico: '📖', title: "MASQUDE Qur'an", desc: "Distribusi Al-Qur'an massal untuk penerima manfaat yayasan dan TPQ binaan" },
      { ico: '🥩', title: 'MASQUDE Halal', desc: 'Edukasi dan sertifikasi sembelih halal untuk program sosial dan kegiatan yayasan' },
      { ico: '💼', title: 'MASQUDE Preneur', desc: 'Pemberdayaan ekonomi penerima manfaat melalui edukasi bisnis dan jaringan reseller' },
      { ico: '🌾', title: 'Wakaf Produktif', desc: 'Optimalkan aset wakaf yayasan melalui skema peternakan produktif bersama NusaQu' },
    ],
  },
  {
    id: 'pesantren', tab: '📚 Pesantren',
    icon: '📚', title: 'Program Pemberdayaan untuk Pesantren',
    desc: 'Pesantren adalah benteng pendidikan Islam. MASQUDE hadir mendukung pesantren dalam literasi Qur\'an, literasi halal, serta kemandirian ekonomi santri dan lembaga.',
    items: [
      { ico: '📖', title: "MASQUDE Qur'an", desc: "Al-Qur'an khusus penghafal dan pelajar untuk seluruh santri, kolaborasi SEJUQ" },
      { ico: '🥩', title: 'MASQUDE Halal', desc: 'Pelatihan juru sembelih halal bersertifikat BNSP untuk santri dan alumni' },
      { ico: '🌿', title: 'MASQUDE Green', desc: 'Program ketahanan pangan pesantren dan pengelolaan lingkungan berkelanjutan' },
      { ico: '🌾', title: 'Wakaf Produktif', desc: 'Manfaatkan lahan pesantren untuk peternakan produktif — NusaQu siap bermitra' },
    ],
  },
  {
    id: 'laz', tab: '💛 LAZ / ZISWAF',
    icon: '💛', title: 'Program Pemberdayaan untuk LAZ / ZISWAF',
    desc: 'Lembaga amil zakat membutuhkan ekosistem yang transparan dan berdampak nyata. MASQUDE menghubungkan potensi ZISWAF dengan program pemberdayaan produktif yang terukur.',
    items: [
      { ico: '📱', title: 'MASQUDE Digital', desc: 'Pencatatan ZISWAF dan laporan penyaluran real-time via Maslam' },
      { ico: '🌾', title: 'Wakaf Produktif', desc: 'Kelola dana wakaf secara produktif melalui usaha peternakan — pasar terjamin NusaQu' },
      { ico: '🐄', title: 'Tabungan Qurban', desc: 'Fasilitasi mustahiq berqurban melalui program cicilan dan tabungan qurban NusaQu' },
      { ico: '💼', title: 'MASQUDE Preneur', desc: 'Pemberdayaan mustahiq menjadi muzakki melalui ekosistem reseller qurban NusaQu' },
    ],
  },
  {
    id: 'komunitas', tab: '🤝 Komunitas',
    icon: '🤝', title: 'Program Pemberdayaan untuk Komunitas Dakwah',
    desc: 'Komunitas dakwah adalah garda terdepan penyebaran Islam. MASQUDE membekali komunitas dengan sumber pendapatan halal dan alat dakwah yang relevan di era digital.',
    items: [
      { ico: '💼', title: 'MASQUDE Preneur', desc: 'Jadikan komunitas dakwah sebagai reseller qurban, edukasi, dan pupuk NusaQu' },
      { ico: '🥩', title: 'MASQUDE Halal', desc: 'Roadshow edukasi sembelih halal ke komunitas sebagai konten dakwah yang bermanfaat' },
      { ico: '📖', title: "MASQUDE Qur'an", desc: "Program HikmahQu sebagai konten kajian rutin dan distribusi Al-Qur'an ke anggota" },
      { ico: '🌿', title: 'MASQUDE Green', desc: 'Kampanye lingkungan islami sebagai program sosial komunitas yang berdampak luas' },
    ],
  },
];

export default function ShowcaseLembaga() {
  const [active, setActive] = useState('masjid');
  const { ref, inView } = useInView({ threshold: 0.05, triggerOnce: true });
  const data = lembagaData.find(l => l.id === active);

  return (
    <section style={styles.section}>
      <div ref={ref} style={{ textAlign: 'center', marginBottom: '2rem', opacity: inView ? 1 : 0, transition: 'opacity 0.6s' }}>
        <div style={{ marginBottom: '0.8rem' }}><span style={styles.lbl}>Manfaat per Lembaga</span></div>
        <h2 style={styles.h2}>Bagaimana MASQUDE<br />Memberdayakan Lembaga Anda?</h2>
        <p style={styles.sub}>Setiap lembaga keislaman memiliki tantangan unik — MASQUDE menyediakan program pemberdayaan yang relevan untuk masing-masing</p>
      </div>

      <div style={styles.tabs}>
        {lembagaData.map(l => (
          <button key={l.id} style={active === l.id ? styles.tabActive : styles.tab}
            onClick={() => setActive(l.id)}
            onMouseEnter={e => { if (active !== l.id) { e.currentTarget.style.background = 'var(--coklat)'; e.currentTarget.style.color = 'var(--kuning2)'; e.currentTarget.style.borderColor = 'var(--coklat)'; }}}
            onMouseLeave={e => { if (active !== l.id) { e.currentTarget.style.background = 'white'; e.currentTarget.style.color = 'var(--coklat)'; e.currentTarget.style.borderColor = 'rgba(123,63,0,.15)'; }}}
          >{l.tab}</button>
        ))}
      </div>

      <div key={active} className="showcase-pane-grid" style={styles.pane}>
        <div style={styles.left}>
          <div style={styles.icon}>{data.icon}</div>
          <h3 style={styles.title}>{data.title}</h3>
          <p style={styles.desc}>{data.desc}</p>
          <a href="#kontak" style={styles.btn}
            onClick={e => { e.preventDefault(); document.querySelector('#kontak')?.scrollIntoView({ behavior: 'smooth' }); }}
          >Daftar sebagai {data.tab.split(' ').slice(1).join(' ')} →</a>
        </div>
        <div style={styles.right}>
          {data.items.map(item => (
            <div key={item.title} style={styles.item}
              onMouseEnter={e => { e.currentTarget.style.borderColor = 'var(--kuning)'; e.currentTarget.style.boxShadow = '0 4px 18px rgba(123,63,0,.08)'; }}
              onMouseLeave={e => { e.currentTarget.style.borderColor = 'rgba(123,63,0,.1)'; e.currentTarget.style.boxShadow = 'none'; }}
            >
              <div style={styles.ico}>{item.ico}</div>
              <div>
                <strong style={styles.itemTitle}>{item.title}</strong>
                <p style={styles.itemDesc}>{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

const styles = {
  section: { background: 'var(--krem2)', padding: '6rem 5%' },
  lbl: {
    display: 'inline-block', background: 'var(--coklat)', color: 'var(--kuning2)',
    padding: '0.28rem 0.95rem', borderRadius: '2rem',
    fontSize: '0.72rem', fontWeight: 800, letterSpacing: '3px', textTransform: 'uppercase',
  },
  h2: {
    fontFamily: 'Lora, serif', fontSize: 'clamp(1.7rem, 3.5vw, 2.7rem)',
    fontWeight: 700, color: 'var(--coklat)', marginBottom: '0.8rem',
  },
  sub: { color: 'var(--abu)', fontSize: '0.97rem', maxWidth: '600px', margin: '0 auto' },
  tabs: { display: 'flex', gap: '0.6rem', flexWrap: 'wrap', justifyContent: 'center', marginBottom: '2rem' },
  tab: {
    background: 'white', border: '1.5px solid rgba(123,63,0,.15)',
    color: 'var(--coklat)', padding: '0.52rem 1.15rem', borderRadius: '2rem',
    fontFamily: 'Plus Jakarta Sans, sans-serif', fontSize: '0.84rem', fontWeight: 700,
    cursor: 'pointer', transition: 'all 0.25s',
  },
  tabActive: {
    background: 'var(--coklat)', border: '1.5px solid var(--coklat)',
    color: 'var(--kuning2)', padding: '0.52rem 1.15rem', borderRadius: '2rem',
    fontFamily: 'Plus Jakarta Sans, sans-serif', fontSize: '0.84rem', fontWeight: 700,
    cursor: 'pointer', transition: 'all 0.25s',
  },
  pane: {
    display: 'grid', gridTemplateColumns: '1fr 1fr',
    gap: '2.5rem', alignItems: 'start',
    maxWidth: '980px', margin: '0 auto',
    animation: 'fadeUp 0.4s ease',
  },
  left: {},
  icon: { fontSize: '2.8rem', marginBottom: '0.8rem' },
  title: { fontFamily: 'Lora, serif', fontSize: '1.75rem', fontWeight: 700, color: 'var(--coklat)', marginBottom: '0.7rem' },
  desc: { color: 'var(--abu)', fontSize: '0.93rem', lineHeight: 1.8, marginBottom: '1.5rem' },
  btn: {
    display: 'inline-block', background: 'var(--coklat)', color: 'var(--kuning2)',
    padding: '0.72rem 1.5rem', borderRadius: '8px',
    fontSize: '0.88rem', fontWeight: 700, textDecoration: 'none',
  },
  right: {},
  item: {
    display: 'flex', gap: '0.9rem', alignItems: 'flex-start',
    background: 'white', border: '1.5px solid rgba(123,63,0,.1)',
    borderRadius: '12px', padding: '0.95rem 1.1rem', marginBottom: '0.7rem',
    transition: 'all 0.25s', cursor: 'default',
  },
  ico: {
    width: '38px', height: '38px', minWidth: '38px',
    background: 'var(--krem2)', borderRadius: '9px',
    display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.1rem',
  },
  itemTitle: { display: 'block', color: 'var(--coklat)', fontSize: '0.9rem', marginBottom: '0.18rem' },
  itemDesc: { color: 'var(--abu)', fontSize: '0.8rem', lineHeight: 1.5 },
};
